"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProductUpdatesPlatform = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _header = _interopRequireDefault(require("../header"));

var _buttonControl = _interopRequireDefault(require("../../preact-components/button-control"));

var _assets = _interopRequireDefault(require("../../preact-components/assets"));

var _SimplePanel = _interopRequireDefault(require("../ui-components/SimplePanel"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ProductUpdatesPlatform = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductUpdatesPlatform, _Component);

  var _super = _createSuper(ProductUpdatesPlatform);

  function ProductUpdatesPlatform() {
    (0, _classCallCheck2.default)(this, ProductUpdatesPlatform);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(ProductUpdatesPlatform, [{
    key: "render",
    value: function render() {
      return (0, _preact.h)("div", {
        className: "product-updates-platform-page"
      }, (0, _preact.h)(_header.default, {
        title: "Product Updates",
        disableSaveButton: true,
        disableCancelButton: true,
        customButtons: [(0, _preact.h)("a", {
          href: (0, _absoluteUrlRuntime.resolveUrl)("/product-update/overview"),
          target: "_blank"
        }, (0, _preact.h)(_buttonControl.default, {
          title: (0, _preact.h)("div", {
            className: "product-updates-overview-link"
          }, "Go to product updates overview page", (0, _preact.h)(_assets.default, {
            icon: 'openInNew',
            width: 16,
            height: 16
          })),
          variant: "secondary",
          newStyle: true,
          size: "medium"
        }))]
      }), (0, _preact.h)("h2", {
        className: "panel-new__heading product-updates-platform-settings"
      }, "Setting"), (0, _preact.h)(_SimplePanel.default, {
        className: "product-updates-platform-permissions-panel",
        image: (0, _preact.h)(_assets.default, {
          icon: "key",
          width: 30,
          height: 30,
          color: "#0069FF"
        })
      }, (0, _preact.h)("a", {
        className: "product-updates-platform-permissions-link",
        href: (0, _absoluteUrlRuntime.resolveUrl)("/platform/product-updates/permissions")
      }), (0, _preact.h)("div", {
        className: "product-updates-permissions__title"
      }, (0, _preact.h)("h5", null, "Permissions")), (0, _preact.h)("div", {
        className: "product-updates-permissions__description"
      }, "Manage visibility and reply permissions")));
    }
  }]);
  return ProductUpdatesPlatform;
}(_preact.Component);

exports.ProductUpdatesPlatform = ProductUpdatesPlatform;
var _default = ProductUpdatesPlatform;
exports.default = _default;